module.exports = __webpack_public_path__ + "img/aboutUsImg04.94f2be54.png";